<div class="mnt-content mdl-grid mdl-grid--no-spacing">
   <div class="mdl-cell mdl-cell--12-col">

          <itec-form ng-show="$root.issuperadmin"
            name="ctrl.formulari.nom"
            fields="ctrl.formulari.camps"
            ng-model="ctrl.cercaObj"
            ng-submit-function="ctrl.formulari.func()"
            errors="ctrl.errors"
            submit-button-text="DEFAULT_CERCAR"
            backbutton="false"
            submit-button-dynamic="false">
          </itec-form>

  </div>

  <div class="mdl-cell mdl-cell--12-col mdl-grid mdl-grid--no-spacing">
     <itec-simple-list
        class="mdl-cell mdl-cell--12-col"
        items="ctrl.llista"
        fields="ctrl.fields"
        show-edit-button="false"
        show-delete-button="false"
        show-add-button="false"
        itec-infinite-scroll-function="ctrl.load"
        threshold="100"
        can-load="ctrl.canLoad"
        click-function="ctrl.view"
        all-row-clickable="true"
        id-selected="$stateParams.idEntitat">
      </itec-simple-list>
  </div>
</div>
